export default __webpack_public_path__ + "static/media/icon-business-model-subscription.24b8017d.svg";